// assets
import { BuildOutlined, FolderViewOutlined, CopyOutlined } from '@ant-design/icons';

const icons = {
  BuildOutlined,
  CopyOutlined,
  FolderViewOutlined
};

const menuItems = {
  id: 'exam-management',
  title: 'Bài thi',
  type: 'group',
  roles: ['admin', 'teacher', 'editor', 'student'],
  children: [
    {
      id: 'class-detail',
      title: 'Quản lý lớp',
      type: 'item',
      url: '/class-detail',
      icon: icons.BuildOutlined,
      target: false,
      visible: false,
      roles: ['admin', 'teacher']
    },
    {
      id: 'exam',
      title: 'Bài thi',
      type: 'item',
      url: '/exam',
      icon: icons.BuildOutlined,
      target: false,
      visible: true,
      roles: ['admin', 'teacher', 'editor', 'student']
    },
    {
      id: 'direct-mock-exam',
      title: 'Thi thử trực tiếp',
      type: 'item',
      url: '/direct-mock-exam',
      icon: icons.FolderViewOutlined,
      target: false,
      visible: true,
      roles: ['admin', 'teacher', 'editor']
    },
    {
      id: 'direct-mock-exam-results',
      title: 'Điểm thi thử',
      type: 'item',
      url: '/direct-mock-exam-results',
      icon: icons.FolderViewOutlined,
      target: false,
      visible: true,
      roles: ['admin', 'teacher', 'editor']
    },
    {
      id: 'class',
      title: 'Lớp',
      type: 'item',
      url: '/class',
      icon: icons.CopyOutlined,
      target: false,
      visible: true,
      roles: ['admin', 'teacher']
    },
    {
      id: 'review',
      title: 'Chấm bài viết',
      type: 'item',
      url: '/review',
      icon: icons.FolderViewOutlined,
      target: false,
      visible: true,
      roles: ['admin', 'teacher']
    }
  ]
};

export default menuItems;
